var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayPersonR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M10 11.3333C10.8768 11.3327 11.7398 11.4362 12.5898 11.6428C13.4403 11.8496 14.2802 12.1581 15.1094 12.5715C15.4265 12.7368 15.6802 12.9746 15.876 13.2932C16.07 13.6091 16.1664 13.9519 16.166 14.3323V15.0002C16.1659 15.3249 16.0564 15.5909 15.8232 15.8245C15.5905 16.0575 15.325 16.1667 15 16.1663H5C4.6752 16.1663 4.40976 16.0565 4.17676 15.8235C3.97284 15.6195 3.86236 15.3908 3.83789 15.1184L3.83301 14.9993V14.3333C3.83301 13.9519 3.93001 13.6086 4.12402 13.2932C4.31961 12.9754 4.57335 12.7383 4.88965 12.5725C5.71876 12.158 6.55887 11.8485 7.40918 11.6428C8.25952 11.4372 9.12281 11.3338 10 11.3333ZM10 3.83325C10.7829 3.83333 11.4403 4.10658 12 4.66626C12.5597 5.22594 12.8329 5.8834 12.833 6.66626C12.833 7.44926 12.5598 8.10748 12 8.66724C11.4404 9.22681 10.7828 9.50017 10 9.50024C9.217 9.50024 8.55878 9.22699 7.99902 8.66724C7.43927 8.10748 7.16602 7.44926 7.16602 6.66626C7.16609 5.88347 7.43945 5.2259 7.99902 4.66626C8.55878 4.1065 9.217 3.83325 10 3.83325Z",
  stroke: "black"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayPersonR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-person-r.e3f65e0260c3a5361ce63685b80e180e.svg";